export const GET_INVITES = '[Invites] Get invites';
export const GET_INVITES_SUCCESS = '[Invites] Get invites Success';
export const GET_INVITES_ERROR = '[Invites] Get invites Error';

export const CREATE_INVITES = '[Invites] Create invites';
export const CREATE_INVITES_SUCCESS = '[Invites] Create invites Success';
export const CREATE_INVITES_ERROR = '[Invites] Create invites Error';

export const CANCEL_INVITE = '[Invites] Cancel invite';
export const CANCEL_INVITE_SUCCESS = '[Invites] Cancel invite Success';
export const CANCEL_INVITE_ERROR = '[Invites] Cancel invite Error';

export const RESEND_INVITE = '[Invites] Resend invite';
export const RESEND_INVITE_SUCCESS = '[Invites] Resend invite Success';
export const RESEND_INVITE_ERROR = '[Invites] Resend invite Error';

export const ACCEPT_INVITE = '[Invites] Accept invite';
export const ACCEPT_INVITE_SUCCESS = '[Invites] Accept invite Success';
export const ACCEPT_INVITE_ERROR = '[Invites] Accept invite Error';

export const REJECT_INVITE = '[Invites] Reject invite';
export const REJECT_INVITE_SUCCESS = '[Invites] Reject invite Success';
export const REJECT_INVITE_ERROR = '[Invites] Reject invite Error';

export const GET_USER_INVITES = '[Invites] Get user invites';
export const GET_USER_INVITES_SUCCESS = '[Invites] Get user invites Success';
export const GET_USER_INVITES_ERROR = '[Invites] Get user invites Error';

export const NEW_INVITE_DRAFT = '[Invites] New invite draft';
export const EDIT_INVITE_DRAFT = '[Invites] Edit invite draft';
export const REMOVE_INVITE_DRAFT = '[Invites] Remove invite draft';

export const RESET_INVITES_STORE = '[Invites] Reset store';

export const GET_RECORD_LABEL_INVITES = '[Invites] Get Record Label invites';
export const GET_RECORD_LABEL_INVITES_SUCCESS =
  '[Invites] Get Record Label invites Success';
export const GET_RECORD_LABEL_INVITES_ERROR =
  '[Invites] Get Record Label invites Error';
